import {
  getAuctionClarifications,
  createAuctionClarification,
  answerAuctionClarification,
} from '@/resources/electronicAuctions/auctionsClarifications';
import { rejectManifestacaoRequest, findManifestacaoIndex } from '@/utils/manifestacaoError';

const types = {
  CLARIFICATION_NEW: 'CLARIFICATION_NEW',
  CLARIFICATION_RESPONSE: 'CLARIFICATION_RESPONSE',
  CLARIFICATIONS: 'CLARIFICATIONS',
};

const normalizeClarification = clarification => {
  const clarificationClone = { ...clarification };

  clarificationClone.createdAt = new Date(clarification.createdAt);
  clarificationClone.anexos = Array.isArray(clarification.anexos) ? clarification.anexos : [];
  clarificationClone.anexosResposta = Array.isArray(clarification.anexosResposta)
    ? clarification.anexosResposta
    : [];

  if (clarificationClone.response?.date) {
    clarificationClone.response.date = new Date(clarificationClone.response.date);
  }

  return clarificationClone;
};

const preserveAnexos = (atual, atualizado) => {
  let next = { ...atualizado };

  if (!next.anexos.length && atual?.anexos?.length) {
    next = { ...next, anexos: atual.anexos };
  }

  if (!next.anexosResposta?.length && atual?.anexosResposta?.length) {
    next = { ...next, anexosResposta: atual.anexosResposta };
  }

  return next;
};

const mutations = {
  [types.CLARIFICATIONS](state, clarifications) {
    if (clarifications && Array.isArray(clarifications)) {
      state.clarifications = clarifications.map(normalizeClarification);
    }
  },

  [types.CLARIFICATION_RESPONSE](state, clarification) {
    if (clarification && typeof clarification === 'object') {
      const index = findManifestacaoIndex(state.clarifications, clarification);
      const normalized = preserveAnexos(
        index > -1 ? state.clarifications[index] : null,
        normalizeClarification(clarification),
      );

      if (index > -1) {
        state.clarifications.splice(index, 1, normalized);
      } else {
        state.clarifications.unshift(normalized);
      }
    }
  },
  [types.CLARIFICATION_NEW](state, clarification) {
    if (clarification && typeof clarification === 'object') {
      const normalized = normalizeClarification(clarification);
      const index = findManifestacaoIndex(state.clarifications, normalized);
      if (index > -1) {
        state.clarifications.splice(
          index,
          1,
          preserveAnexos(state.clarifications[index], normalized),
        );
      } else {
        state.clarifications.unshift(normalized);
      }
    }
  },
};

const actions = {
  async answerAuctionClarification({ commit }, { auctionId, clarificationId, data }) {
    const response = await answerAuctionClarification(auctionId, clarificationId, data);
    if (response.status !== 200) return rejectManifestacaoRequest(response);
    commit(types.CLARIFICATION_RESPONSE, response.data);
    return response.data;
  },
  async createAuctionClarification({ commit }, { auctionId, data }) {
    const response = await createAuctionClarification(auctionId, data);
    if (response.status !== 201) return rejectManifestacaoRequest(response);
    commit(types.CLARIFICATION_NEW, response.data);
    return response.data;
  },
  async getAuctionClarifications({ commit }, ofertaCompraId) {
    const response = await getAuctionClarifications(ofertaCompraId);
    if (response.status !== 200) return rejectManifestacaoRequest(response);
    return commit(types.CLARIFICATIONS, response.data);
  },
  updateAuctionClarifications({ commit }, clarification) {
    commit(types.CLARIFICATION_NEW, clarification);
  },
};

const state = {
  clarifications: [],
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
